export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6578.92ff0001.jpg";